<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <path d="M0 0H18V19H0z" transform="translate(-1240 -383) translate(1240 383)" />
          <path
            :fill="color"
            d="M17.5 14c.276 0 .5.224.5.5v2c0 1.38-1.12 2.5-2.5 2.5h-12C2.12 19 1 17.88 1 16.5v-2c0-.276.224-.5.5-.5s.5.224.5.5V16c0 1.105.895 2 2 2h11c1.105 0 2-.895 2-2v-1.5c0-.276.224-.5.5-.5zm-8-13c.276 0 .5.224.5.5v10.827l4.233-4.197c.188-.186.478-.17.648.034.151.181.157.451.025.64l-.056.066-5.042 5c-.153.152-.376.17-.547.057l-.07-.057-5.041-5c-.187-.186-.201-.502-.03-.706.15-.182.396-.214.58-.088l.067.054L9 12.329V1.5c0-.276.224-.5.5-.5z"
            transform="translate(-1240 -383) translate(1240 383)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
